import React, { useState, useEffect } from "react"
import API from "../../api/axios" 
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"

// validation Validation
import * as Yup from "yup"
// import { usevalidation } from "validation"
import { useFormik } from "formik"
//redux
import { useSelector, useDispatch } from "react-redux"

import withRouter from "components/Common/withRouter"

import { useLocation, useNavigate } from "react-router-dom"

import { ToastContainer, toast } from "react-toastify"

const PatientProfile = () => {
  //meta title
  document.title = "Profile | Skote - React Admin & Dashboard Template"

  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const dispatch = useDispatch()
  const location = useLocation()
  // const patientData = location.state?.patientData
  const navigate = useNavigate()

  const [patientData, setPatientData] = useState(
    location.state?.patientData || {},
  )

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: patientData.id,
      fname: patientData?.fname || "",
      lname: patientData?.lname || "",
      email: patientData?.email || "",
      gender: patientData?.gender || "",
      phone: patientData?.phone || "",
      addressLine1: patientData?.addressLine1 || "",
      addressLine2: patientData?.addressLine2 || "",
      city: patientData?.city || "",
      state: patientData?.state || "",
      zipCode: patientData?.zipCode || "",
      country: "India",
    },
    validationSchema: Yup.object().shape({
      fname: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name cannot exceed 50 characters")
        .required("First name is required"),
      lname: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name cannot exceed 50 characters")
        .required("Last name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      gender: Yup.string()
        .oneOf(["male", "female"], "Select a valid gender")
        .required("Gender is required"),
      phone: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be 10 digits")
        .required("Phone number is required"),

      addressLine1: Yup.string().required("addressLine1 is required"),

      addressLine2: Yup.string().notRequired(),
      city: Yup.string().required("city is required"),
      state: Yup.string().required("state is required"),
      zipCode: Yup.string()

        .required("ZipCode is required"),
    }),
    onSubmit: async values => {
      console.log("Submitting values:", values)
      await updatePatient1(values)
    },
  })

  const { isSubmitting } = validation
  console.log("valiadation error", validation?.errors)

  const updatePatient1 = async updatedData => {
    try {
      const authToken = localStorage.getItem("authToken")
      console.log("Sending updated data:", updatedData)

      const response = await API.put(
        `/patients/${updatedData.id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${authToken} `,
            "Content-Type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("User updated successfully ", { autoClose: 2000 })

        setTimeout(() => {
          navigate("/patient")
        }, 2000)
      } else {
        toast.error("Failed to update patient. Please try again.")
      }
    } catch (error) {
      console.error("Error updating patient data:", error)
      toast.error("Error updating patient.")
    }
  }

  // open model
  const handleDelete = () => {
    if (!patientData || !patientData.id) {
      toast.error("Invalid patient data.")
      return
    }
    setShowDeleteModal(true) // just open modal
  }

  // delete patient data
  const confirmDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.delete(
        `/patients/${patientData.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-type": "application/json",
          },
        },
      )

      if (response.status === 200) {
        toast.success("Patient deleted successfully!", { autoClose: 2000 })
        setShowDeleteModal(false)
        navigate("/patient")
      } else {
        toast.error("Failed to delete patient. Please try again.")
      }
    } catch (error) {
      toast.error("Error deleting patient.")
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content p-0">
        <Container fluid>
          <h4 className="card-title mb-4">Change Patient Profile</h4>

          <Card>
            <CardBody>
              <form
                action=""
                className="form-horizontal"
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">First Name</Label>
                      <Input
                        name="fname"
                        // value={name}
                        className="form-control"
                        placeholder="First Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.fname || ""}
                        invalid={
                          validation.touched.fname && validation.errors.fname
                            ? true
                            : false
                        }
                      />
                      {validation.touched.fname && validation.errors.fname && (
                        <div className="text-danger">
                          {validation.errors.fname}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">lname</Label>
                      <Input
                        name="lname"
                        // value={name}
                        className="form-control"
                        placeholder=" Last Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lname || ""}
                        invalid={
                          validation.touched.lname && validation.errors.lname
                            ? true
                            : false
                        }
                      />

                      {validation.touched.fname && validation.errors.fname && (
                        <div className="text-danger">
                          {validation.errors.lname}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label for="gender">Gender</Label>
                      <Input
                        type="select"
                        name="gender"
                        id="gender"
                        className="form-control"
                        placeholder=" Gender"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.gender}
                        invalid={
                          validation.touched.gender && validation.errors.gender
                            ? true
                            : false
                        }
                      >
                        <option value="">Select Gender</option>{" "}
                        {/* Default placeholder */}
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </Input>
                      {validation.touched.gender &&
                        validation.errors.gender && (
                          <FormFeedback type="invalid">
                            {validation.errors.gender}
                          </FormFeedback>
                        )}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Phone</Label>
                      <Input
                        name="phone"
                        // value={name}
                        className="form-control"
                        placeholder="+91 8378655768"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          validation.touched.phone && validation.errors.phone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone && validation.errors.phone && (
                        <div className="text-danger">
                          {validation.errors.phone}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="donereaply@gmail.com"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email && (
                        <div className="text-danger">
                          {validation.errors.email}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">AddressLine1</Label>
                      <Input
                        name="addressLine1"
                        className="form-control"
                        placeholder="addressLine1"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.addressLine1 || ""}
                        invalid={
                          validation.touched?.addressLine1 &&
                          validation.errors?.addressLine1
                            ? true
                            : false
                        }
                      />
                      {validation.touched.addressLine1 &&
                        validation.errors.addressLine1 && (
                          <div className="text-danger">
                            {validation.errors.addressLine1}
                          </div>
                        )}
                      <small className="form-text text-muted">
                        Street address or house number
                      </small>
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">AddressLine2</Label>
                      <Input
                        name="addressLine2"
                        className="form-control"
                        placeholder="addressLine2"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.addressLine2 || ""}
                        invalid={
                          validation.touched?.addressLine2 &&
                          validation.errors?.addressLine2
                            ? true
                            : false
                        }
                      />
                      {validation.touched.addressLine2 &&
                        validation.errors.addressLine2 && (
                          <div className="text-danger">
                            {validation.errors.addressLine2}
                          </div>
                        )}
                      <small className="form-text text-muted">
                        Apartment, Suite, Floor, etc
                      </small>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">City</Label>
                      <Input
                        name="city"
                        className="form-control"
                        placeholder="eg:Mumbai"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.city || ""}
                        invalid={
                          validation.touched?.city && validation.errors?.city
                            ? true
                            : false
                        }
                      />
                      {validation.touched.city && validation.errors.city && (
                        <div className="text-danger">
                          {validation.errors.city}
                        </div>
                      )}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">State</Label>
                      <Input
                        name="state"
                        className="form-control"
                        placeholder="eg:Maharashtra"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.state || ""}
                        invalid={
                          validation.touched?.state && validation.errors?.state
                            ? true
                            : false
                        }
                      />
                      {validation.touched.state && validation.errors.state && (
                        <div className="text-danger">
                          {validation.errors.state}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">ZipCode</Label>
                      <Input
                        name="zipCode"
                        className="form-control"
                        placeholder="400087"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.zipCode || ""}
                        invalid={
                          validation.touched?.zipCode &&
                          validation.errors?.zipCode
                            ? true
                            : false
                        }
                      />
                      {validation.touched.zipCode &&
                        validation.errors.zipCode && (
                          <div className="text-danger">
                            {validation.errors.zipCode}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="form-group">
                      <Label className="form-label">Country</Label>
                      <Input
                        name="country"
                        value="India"
                        className="form-control"
                        placeholder="eg:India"
                        type="text"
                        readOnly
                        invalid={
                          validation.touched?.country &&
                          validation.errors?.country
                            ? true
                            : false
                        }
                      />
                      {validation.touched.country &&
                        validation.errors.country && (
                          <div className="text-danger">
                            {validation.errors.country}
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>

                <div
                  className="text-center mt-4"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContet: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    color="primary"
                    className="px-3 border"
                    disabled={isSubmitting}
                  >
                    Update Patient Profile
                  </Button>

                  <Button
                    type="button"
                    color="danger"
                    className="px-3 border"
                    onClick={handleDelete}
                  >
                    Delete Patient
                  </Button>
                  <Button
                    type="button"
                    color="secondary"
                    className="px-3 border"
                    onClick={() => navigate("/patient")}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)}>
        <ModalHeader toggle={() => setShowDeleteModal(false)}>
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete patient{" "}
          <b>
            {patientData.fname} {patientData.lname}
          </b>
          ?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button color="danger" onClick={confirmDelete}>
            Confirm Delete
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(PatientProfile)
